export default __webpack_public_path__ + "static/media/banner1.170ce73c.jpg";